import { render } from "./Support.vue?vue&type=template&id=7038605a&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"

import "./Support.vue?vue&type=style&index=0&id=7038605a&scoped=true&lang=css"

import exportComponent from "C:\\Development\\app.vrtag.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7038605a"]])

export default __exports__